import axios from "axios";

/*
 * ---------------------------------------------------------------------
 * import Action types
 * ---------------------------------------------------------------------
 */
import {
    SET_APPOINTMENT_LIST,
    SET_APPOINTMENT_IDENTIFIER
} from "./types";

import {
    setError
} from "src/shared_modules/veu-visitors-core/actions/system";

import { getConfig } from "src/config/axios";
import { currentLanguage } from "src/shared_modules/i18n";
/*
 * ---------------------------------------------------------------------
 * internal Actions
 * ---------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------
 * Public Actions
 * ---------------------------------------------------------------------
 */
export const setAppointmentList = ( appointmentList ) => ({
    type: SET_APPOINTMENT_LIST,
    payload: appointmentList
});

export const setAppointmentIdentifier = ( appointmentIdentifier ) => ({
    type: SET_APPOINTMENT_IDENTIFIER,
    payload: appointmentIdentifier
});

/*
 * ---------------------------------------------------------------------
 * async thunks
 * ---------------------------------------------------------------------
 */
export const fetchListOfAppointments = ( identifier ) => {
    return async ( dispatch, getState ) => {
        let axiosconf = getConfig().veu;
        let url = "/visitors/appointments/" + identifier;
        let headers = axiosconf.headers;
        headers["VEU-EVENT"] = getState().event.path;
        headers["VEU-LANG"] = currentLanguage().code2;

        dispatch( setError(null) );

        const done = await axios.get(url, {
            // options
            crossDomain: true,
            headers: headers
        })
        .then( (response) => {
            //console.log( JSON.stringify(response, null,2) );
            if (response.status === 200) {
                dispatch( setAppointmentList(response.data) );
                //console.log("Appointment list:  "+JSON.stringify(response.data));
            }
        })
        .catch( (error) => {
            dispatch( setError( error.response ) );
        });
        return done;
    }
}

export const sendAppointmentRequest = ( data ) => {
    return async ( dispatch, getState ) => {
        let axiosconf = getConfig().veu;
        let url = "/visitors/appointments/request";
        let headers = axiosconf.headers;
        headers["VEU-EVENT"] = getState().event.path;
        headers["VEU-LANG"] = currentLanguage().code2;

        dispatch( setError(null) );

        const done = await axios.post(url,
            { fields: data },
            {
            // options
            crossDomain: true,
            headers: headers
        })
        .then( (response) => {
            if (response.status === 200) {
                console.log("sendAppointmentRequest success");
            }
        })
        .catch( (error) => {
        //  console.log("sendAppointmentsRegisterMail"+ error.response);
            dispatch( setError( error.response ) );
        });
        return done;
    }
}
